import { useQuery } from "@bb-vendure/admin-ui/react";
import { gql } from "graphql-tag";

export const CUSTOMS_CLEARANCE_BODY = `
files {
  id
  source
  name
  preview
  createdAt
}
id
state
order {
  id
}
`;

export const EXCLUDE_FILE_CUSTOMS_CLEARANCE_BODY = `

id
state
order {
  id
}
`;

function getCustomsClearanceByOrder(includeFiles: boolean) {
  return gql`
  query GetCustomsClearance($id: ID!) {
    customsClearance(orderId: $id) {
    ${
      includeFiles
        ? CUSTOMS_CLEARANCE_BODY
        : EXCLUDE_FILE_CUSTOMS_CLEARANCE_BODY
    }
    }
  }
`;
}

export default function useGetCustomsClearance<T>(
  id: string,
  includeFiles: boolean
) {
  return useQuery<T>(getCustomsClearanceByOrder(includeFiles), {
    id: id,
  });
}
